import {
	IconLayersOutline18 as Layers,
	IconCircleDottedOutline18 as ProductlaneMark,
} from "nucleo-ui-outline-18"

import type { IconType } from "@productlane/ui"
import type { SourceValue } from "@productlane/zero/queries"
import {
	AttioIcon,
	HubspotIconGray,
	IntercomIconGray,
	ZendeskIcon,
} from "@productlane/ui"

export interface SourceOption {
	value: SourceValue
	label: string
	Icon: IconType
}

export const SOURCE_OPTIONS: SourceOption[] = [
	{ value: "productlane", label: "Productlane", Icon: ProductlaneMark },
	{ value: "attio", label: "Attio", Icon: AttioIcon },
	{ value: "hubspot", label: "HubSpot", Icon: HubspotIconGray },
	{ value: "intercom", label: "Intercom", Icon: IntercomIconGray },
	{ value: "zendesk", label: "Zendesk", Icon: ZendeskIcon },
	{ value: "productboard", label: "Productboard", Icon: Layers },
]
